import type { PropsWithChildren } from 'react'
import { Keyboard, Platform, Pressable, type StyleProp, type ViewStyle } from 'react-native'
import { AvoidSoftInputView } from 'react-native-avoid-softinput'

interface DismissKeyboardViewProps extends PropsWithChildren {
    style?: StyleProp<ViewStyle>
}

export function DismissKeyboardView({ children, style }: DismissKeyboardViewProps) {
    if (Platform.OS === 'web') {
        return <AvoidSoftInputView style={style}>{children}</AvoidSoftInputView>
    }

    return (
        <Pressable onPress={Keyboard.dismiss}>
            <AvoidSoftInputView style={style}>{children}</AvoidSoftInputView>
        </Pressable>
    )
}
